export const initialState = {
  request: null,
  loadingNews: false,
  errorNews: null,
  news: [],
};

export function reducer(state, action) {
  switch (action.type) {
    case "REQUEST_LIST_NEWS":
      return {
        ...state,
        request: action.payload?.request,
        loadingNews: true,
        errorNews: null,
      };
    case "LIST_NEWS_SUCCESS":
      return {
        ...state,
        request: null,
        loadingNews: false,
        news: action.payload.items,
      };
    case "LIST_NEWS_ERROR":
      return {
        ...state,
        request: null,
        loadingNews: false,
        errorNews: action.error,
      };
    default:
      return state;
  }
}
